import { AxiosInstance } from 'axios';
import { AddRewardParams, GetListHistoryParams, ProjectRewardDTO, RewardHistoryDTO, RewardItemDTO } from '../../types/apiType';
import { PaginatedConnection, PaginatedQueryParams } from '../../types/common';

export default class ProjectService {
  constructor(private axios: AxiosInstance) {}

  /* User services */

  getListRewardHistory = async (params?: GetListHistoryParams): Promise<PaginatedConnection<RewardHistoryDTO>> => {
    const { data } = await this.axios.get('reward/history', { params });
    return data;
  };

  getListRewardItem = async (params?: PaginatedQueryParams): Promise<PaginatedConnection<RewardItemDTO>> => {
    const { data } = await this.axios.get('reward/item', { params });
    return data;
  };
  /* Admin services */

  updateRewardItem = async (body: { id: string; params: { name: string; coin: number }; image?: File }): Promise<null> => {
    const bodyFormData = new FormData();
    if (body.image) {
      bodyFormData.append('image', body.image);
    }
    bodyFormData.append('name', body.params.name);
    bodyFormData.append('coin', body.params.coin.toString());
    const { data } = await this.axios.put(`reward/item/${body.id}`, bodyFormData);
    return data;
  };

  createRewardItem = async (body: { image: File; params: { name: string; coin: number } }): Promise<null> => {
    const bodyFormData = new FormData();
    bodyFormData.append('image', body.image);
    bodyFormData.append('name', body.params.name);
    bodyFormData.append('coin', body.params.coin.toString());
    const { data } = await this.axios.post('reward/item', bodyFormData);
    return data;
  };

  getRewardItemById = async (id: string): Promise<RewardItemDTO> => {
    const { data } = await this.axios.get(`reward/item/${id}`);
    return data;
  };

  getRewardById = async (id: string): Promise<ProjectRewardDTO> => {
    const { data } = await this.axios.get(`reward/${id}`);
    return data;
  };

  getListRewardAdmin = async (params?: PaginatedQueryParams): Promise<PaginatedConnection<ProjectRewardDTO>> => {
    const { data } = await this.axios.get('reward', { params });
    return data;
  };

  deleteReward = async (id: string) => {
    const { data } = await this.axios.delete(`reward/${id}`);
    return data;
  };

  deleteRewardItem = async (id: string) => {
    const { data } = await this.axios.delete(`reward/item/${id}`);
    return data;
  };

  addRewardForSingleProject = async (params: AddRewardParams) => {
    const { projectId, type, target, coin, customCoin } = params;
    const { data } = await this.axios.post(`reward`, {
      projectId,
      type,
      target: target || null,
      coin: Number(customCoin || coin),
    });
    return data;
  };

  addRewardForAllProject = async (params: AddRewardParams) => {
    const { type, target, coin, customCoin } = params;

    const { data } = await this.axios.post(`reward/all`, {
      type,
      target: target || null,
      coin: Number(customCoin || coin),
    });
    return data;
  };

  updateReward = async (params: AddRewardParams) => {
    const { type, target, coin, customCoin, rewardId, isDefault } = params;

    const { data } = await this.axios.put(`reward/${rewardId}`, {
      type,
      target: target || null,
      coin: Number(customCoin || coin),
      isDefault,
    });
    return data;
  };
}
